import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  subjectsList: [],
  topicsList: [],
  chapterDetails: null,
  courseDetails: null,
  topicDetails: {},
  quizList: [],
  topicUrl: '',
  courseDetailsError: '',
  courseDetailsLoading: '',
  courseDetailsSuccess: null,
  courseStudentsSuccess:null,
  topicTypesListLoading: false,
  topicTypesListSuccess: null,
  topicTypes:[],
  topicTypesListError: '',
  subjectsListLoading: false,
  subjectsListSuccess: null,
  subjectsListError: '',
  quizListApiLoading: false,
  quizListApiSuccess: null,
  quizListApiError: '',
  chapterEditLoading: false,
  chapterEditSuccess: null,
  chapterEditError: '',
  topicCreateLoading: false,
  topicCreateSuccess: null,
  topicCreateError: '',
  topicEditLoading: false,
  topicEditSuccess: null,
  topicEditError: '',
  allCoursesLoading: false,
  allCoursesSuccess: null,
  allCoursesError: '',
  topicProgress: 0,
}

export const courseContentSlice = createSlice({
  name: 'course content',
  initialState,
  reducers: {
    getSubjectsList: (state, action) => {
      state.subjectsList = action.payload
    },
    getTopicsList: (state, action) => {
      state.topicsList = action.payload
    },
    getChapterDetails: (state, action) => {
      state.chapterDetails = action.payload
    },
    setAllCoursesLoading: (state, action) => {
      state.allCoursesLoading = true
      state.allCoursesSuccess = null
      state.allCoursesError = ''
    },
    setAllCoursesSuccess: (state, action) => {
      state.allCoursesLoading = false
      state.allCoursesSuccess = action.payload
      state.allCoursesError = ''
    },
    setAllCoursesError: (state, action) => {
      state.allCoursesLoading = false
      state.allCoursesSuccess = null
      state.allCoursesError = action.payload
    },
    setCourseDetailsLoading: (state, action) => {
      state.courseDetailsLoading = true
      state.courseDetailsError = ''
      state.courseDetailsSuccess = null
    },
    setCourseDetailsSuccess: (state, action) => {
      state.courseDetailsLoading = false
      // state.courseDetailsSuccess = { ...action.payload, data: { ...action.payload.data, subjects: action.payload.data.subjects.map(subject => ({ ...subject, chapters: subject.chapters.map(chapter => ({ ...chapter, topics: chapter.topics.map(topic => ({ ...topic })) })) })) } }
      state.courseDetailsSuccess = action.payload
      state.courseDetailsError = ''
    },
    setCourseStudentsSuccess: (state, action) => {
      state.courseStudentsSuccess = action.payload
    },
    setCourseDetailsError: (state, action) => {
      state.courseDetailsLoading = false
      state.courseDetailsError = action.payload
      state.courseDetailsSuccess = null
    },
    setTopicsListLoading: (state, action) => {
      state.topicTypesListLoading = true;
      state.topicTypesListSuccess = null
      state.topicTypesListError = ''
    },
    setTopicsListSuccess: (state, action) => {
      state.topicTypesListLoading = false;
      state.topicTypesListSuccess = action.payload
      state.topicTypesListError = ''
    },
    setTopicsListError: (state, action) => {
      state.topicTypesListLoading = false;
      state.topicTypesListSuccess = null
      state.topicTypesListError = action.payload
    },
    setSubjectsListLoading: (state, action) => {
      state.subjectsListLoading = true
      state.subjectsListSuccess = null
      state.subjectsListError = ''
    },
    setSubjectsListSuccess: (state, action) => {
      state.subjectsListLoading = false
      state.subjectsListSuccess = action.payload
      state.subjectsListError = ''
    },
    setSubjectsListError: (state, action) => {
      state.subjectsListLoading = false
      state.subjectsListSuccess = null
      state.subjectsListError = action.payload
    },
    setQuizListApiLoading: (state, action) => {
      state.quizListApiLoading = true
      state.quizListApiSuccess = null
      state.quizListApiError = ''
    },
    setQuizListApiSuccess: (state, action) => {
      state.quizListApiLoading = false
      state.quizListApiSuccess = action.payload
      state.quizListApiError = action.payload
    },
    setQuizListApiError: (state, action) => {
      state.quizListApiLoading = false
      state.quizListApiSuccess = null
      state.quizListApiError = action.payload
    },
    setChapterEditLoading: (state, action) => {
      state.chapterEditLoading = true
      state.chapterEditSuccess = null
      state.chapterEditError = ''
    },
    setChapterEditSuccess: (state, action) => {
      state.chapterEditLoading = false
      state.chapterEditSuccess = action.payload
      state.chapterEditError = ''
    },
    setChapterEditError: (state, action) => {
      state.chapterEditLoading = false
      state.chapterEditSuccess = null
      state.chapterEditError = action.payload
    },
    setTopicCreateLoading: (state, action) => {
      state.topicCreateLoading = true;
      state.topicCreateSuccess = null;
      state.topicCreateError = '';
      state.topicProgress= 0
    },
    setTopicCreateSuccess: (state, action) => {
      state.topicCreateLoading = false;
      state.topicCreateSuccess = action.payload;
      state.topicCreateError = '';
    },
    setTopicUploadProgress: (state, action) => {
      state.topicProgress = action.payload;
    },
    setTopicCreateError: (state, action) => {
      state.topicCreateLoading = false;
      state.topicCreateSuccess = null;
      state.topicCreateError = action.payload;
    },
    getTopicDetails: (state, action) => {
      state.topicDetails = action.payload
    },
    getQuizList: (state, action) => {
      state.quizList = action.payload
    },
    setUrl: (state, action) => {
      state.topicUrl = action.payload
    },
    setTopicEditLoading: (state, action) => {
      state.topicEditLoading = true;
      state.topicEditSuccess = null;
      state.topicEditError = '';
    },
    setTopicEditSuccess: (state, action) => {
      state.topicEditLoading = false;
      state.topicEditSuccess = action.payload;
      state.topicEditError = ''
    },
    setTopicEditError: (state, action) => {
      state.topicEditLoading = false;
      state.topicEditSuccess = null;
      state.topicEditError = action.payload;
    },
    resetCourseDetails: (state) => {
      state.courseDetailsError = ''
      state.courseDetailsLoading = ''
      state.courseDetailsSuccess = null
      state.topicTypesListLoading = false
      state.topicTypesListSuccess = null
      state.topicTypesListError = ''
      state.subjectsListLoading = false
      state.subjectsListSuccess = null
      state.subjectsListError = ''
      state.quizListApiLoading = false
      state.quizListApiSuccess = null
      state.quizListApiError = ''
      state.chapterEditLoading = false
      state.chapterEditSuccess = null
      state.chapterEditError = ''
      state.topicCreateLoading = false
      state.topicCreateSuccess = null
      state.topicCreateError = ''
      state.topicEditLoading = false;
      state.topicEditSuccess = null;
      state.topicEditError = '';
    },
    resetTopicDetails: (state) => {
      state.topicDetails = {};
      state.topicEditSuccess = null;
      state.topicCreateSuccess = null;
    },
    resetChapterDetails: (state) => {
      state.chapterEditSuccess = null;
    }
  },
})

// Action creators are generated for each case reducer function
export const { resetTopicDetails, getSubjectsList, getTopicsList, getChapterDetails, setCourseDetailsData, getTopicDetails, resetCourseDetails,resetChapterDetails, getQuizList, setUrl, setCourseDetailsLoading, setCourseDetailsSuccess,setCourseStudentsSuccess, setCourseDetailsError, setTopicsListLoading, setTopicsListSuccess, setTopicsListError, setSubjectsListLoading, setSubjectsListSuccess, setSubjectsListError, setQuizListApiLoading, setQuizListApiSuccess, setQuizListApiError, setChapterEditLoading, setChapterEditSuccess, setChapterEditError, setTopicCreateLoading, setTopicCreateSuccess, setTopicCreateError, setTopicEditLoading, setTopicEditSuccess, setTopicEditError, setAllCoursesLoading, setAllCoursesSuccess, setAllCoursesError,setTopicUploadProgress } = courseContentSlice.actions

export default courseContentSlice.reducer;
